// extracted by mini-css-extract-plugin
export default {"wrapper":"OdmeF","image":"KzRm0","border":"etfnF"};